import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

/**
 * ArchiveToggleButton
 * @param {boolean} isHidden - Initial archive state (true = archived, false = visible)
 */

const ArchiveToggleButton = ({ isHidden, itemId }) => {
  const [archived, setArchived] = useState(isHidden);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    // Show confirmation only when archiving (setting to true)
    if (!archived) {
      const confirmed = window.confirm('Are you sure you want to archive this item?');
      if (!confirmed) return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `/api/items/update-hidden?itemId=${itemId}&hidden=${!archived}`,
        { method: 'GET' }
      );
      if (response.ok) {
        setArchived(!archived);
      } else {
        alert('Failed to update archive state.');
      }
    } catch (err) {
      alert('Network error.');
    }
    setLoading(false);
  };

  return (
    <Button
      variant={archived ? 'danger' : 'outline-success'}
      onClick={handleToggle}
      disabled={loading}
      size="sm"
    >
      {archived ? 'Archived' : 'Archive'}
    </Button>
  );
};

ArchiveToggleButton.propTypes = {
  isHidden: PropTypes.bool.isRequired,
  itemId: PropTypes.number.isRequired,
};

export default ArchiveToggleButton;